import React, { Component } from 'react';
import Payment from 'payment';

class OrderDetailPayment extends Component {

    renderDetail(channel) {

        switch (channel) {
            case '123Service':
                return channel.PaymentResponse.paidChannel
            default:
                const cardType = Payment.fns.cardType('4122');
                return (
                    <p>
                        <img className="visa_logo" />
                        <img src="/resources/img/ic-mastercard.png" alt="" />
                        <span>{'Credit / Debit Card'}</span>
                        <label>{channel.PaymentResponse.pan}</label>
                    </p>
                );
        }
    }

    render() {
        const { order } = this.props;


        return (
            <div className="payment">
                <label>Payment</label>
                {this.renderDetail(order)}
            </div>
        );
    }
}

export default OrderDetailPayment;



// WEBPACK FOOTER //
// ./src/views/orders/OrderDetailPayment.js